import React, { useRef } from 'react';
import './Keyboard.css';

function Keyboard({ onClick, simpleKeyboard, controlArrows, numPad, keyboardRef, errorReaction }) {
    return (
        <div ref={keyboardRef} className="keyboard-container" style={errorReaction === "continue" ? { top: "550px" } : null}>
            <div className='simple-keyboard-main keyboard-padding'>
                {simpleKeyboard.map((row) => {
                    return <div className='row-hg'>
                        {row.map((button) => {
                            return <div onClick={() => onClick(button)} className={`hg-button ${button.label === "" ? "hg-button-space" : ""}`} style={button.active ? { background: "rgb(218, 220, 228)" } : null}>
                                <span>{button.label}</span>
                            </div>
                        })}
                    </div>
                })}
            </div>
            <div className='control-arrows keyboard-padding'>
                {controlArrows.map((area, index) => {
                    return <div className={`${index === 0 ? "simple-keyboard-control" : "simple-keyboard-arrows"}`}>{area.map((row) => {
                        return <div className='row-hg'>
                            {row.map((button) => {
                                return <div onClick={() => onClick(button)} className={`hg-button`} style={button.active ? { background: "rgb(218, 220, 228)" } : null}>
                                    <span>{button.label}</span>
                                </div>
                            })}
                        </div>
                    })}</div>

                })}
            </div>
            <div className='numpad keyboard-padding'>
                {numPad.map((area, index) => {
                    return <div className={`${index === 0 ? "simple-keyboard-numpad" : "simple-keyboard-numpadEnd"}`}>{area.map((row) => {
                        return <div className='row-hg'>
                            {row.map((button) => {
                                return <div onClick={() => onClick(button)} className={`hg-button`} style={button.active ? { background: "rgb(218, 220, 228)" } : null}>
                                    <span>{button.label}</span>
                                </div>
                            })}
                        </div>
                    })}</div>

                })}
            </div>
        </div >
    );
}
export default Keyboard;